


































































import Vue, { PropType } from 'vue';
import { getEmailStatusConfig } from '@/helpers/stats-utils';
import EmailPreviewTooltip from '@/components/Reactivation/EmailPreviewTooltip.vue';
import { CopyToClipboard } from '@/mixins/copy-to-clipboard';
import DBCustomer from '@/helpers/DBCustomer';
import { ascending, descending } from 'd3-array';

export default Vue.extend({
  name: 'ReactivationCampaignRow',
  components: {
    EmailPreviewTooltip,
  },
  mixins: [CopyToClipboard],
  props: {
    campaign: {
      required: true,
      type: Object as PropType<any>,
    },
  },
  data() {
    const dbCus = new DBCustomer(this.campaign.customer, {
      subscriptionDocs: [this.campaign.subscription],
      subscriptionId: this.campaign.canceledSubscriptionId,
    });
    return {
      getEmailStatusConfig,
      ...dbCus,
    };
  },
  computed: {
    emailsSorted(): any[] {
      const emails = [...(this.campaign.emails || [])];
      return emails.sort((a, b) => ascending(a.sendDate, b.sendDate));
    },
    nextEmail(): any {
      const futureEmails = this.emailsSorted.filter((e) => e.sendDate > new Date());
      return futureEmails[0];
    },
  },
});
